import { DataFile } from "interfaces";

import Tag from "ui-components/Tag";

import { useGetColumnType } from "modules/data-files/api";

import { useGetColDropStatusInFile, useGetOriginalName } from "./store";

interface Props {
  fileId: string;
  column: string;
  fileDetails: DataFile.DataFile;
}

const ColumnTag = ({ fileId, fileDetails, column }: Props) => {
  // column is renamed column
  const origName = useGetOriginalName(fileId, column);

  const colType = useGetColumnType(fileId, origName);
  const colIsDropped = useGetColDropStatusInFile(fileId, origName);

  const colIsRenamed = origName !== column;
  const notPresent = !colType;

  return (
    <Tag
      className={
        fileDetails.columns?.includes(origName) && !colIsDropped
          ? colType === "char"
            ? "bg-yellow-300"
            : "bg-green-400"
          : "bg-red-500 text-white"
      }
    >
      {fileDetails.name} ({colType ? colType : "NOT PRESENT"})
      {colIsRenamed
        ? " - RENAMED"
        : notPresent
        ? ""
        : colIsDropped
        ? " - DROPPED"
        : ""}
    </Tag>
  );
};

export default ColumnTag;
